/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StorageStatusOverview } from '../../models/storage-status-overview';

export interface ServerStatusControllerGetStorageStatusOverview$Params {
}

export function serverStatusControllerGetStorageStatusOverview(http: HttpClient, rootUrl: string, params?: ServerStatusControllerGetStorageStatusOverview$Params, context?: HttpContext): Observable<StrictHttpResponse<StorageStatusOverview>> {
  const rb = new RequestBuilder(rootUrl, serverStatusControllerGetStorageStatusOverview.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StorageStatusOverview>;
    })
  );
}

serverStatusControllerGetStorageStatusOverview.PATH = '/server-status/storage';
